<template>
  <layout-card-wrap
    v-loading="loading"
    hasHeaderSlot>
    <template slot="title">选择商品</template>
    <template slot="form">
      <el-input
        v-model="config.productName"
        placeholder="请输入商品名称"
        style="width: 200px">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </template>
    <el-table
      v-loading="loading"
      border
      :data="list"
      highlight-current-row
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="currentId"
            :label="row.productId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="商品名称"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.productName }} <span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
        </template>
      </el-table-column>
      <el-table-column
        label="商品编码"
        width="120"
        :resizable="false"
        prop="productNumber">
      </el-table-column>
      <el-table-column
        label="商品类型"
        width="120"
        :resizable="false"
        prop="categoryName">
      </el-table-column>
      <el-table-column
        label="商品系列"
        width="160"
        :resizable="false"
        prop="productLineName">
      </el-table-column>
      <!-- <el-table-column
        label="贸易类别"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.tradeType | tradeType() }}
        </template>
      </el-table-column>
      <el-table-column
        label="标签类型"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.tagType | tagType() }}
        </template>
      </el-table-column>
      <el-table-column
        label="赋码方式"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.codingType | codingType() }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="备案时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </template>
  </layout-card-wrap>
</template>

<script>
export default {
  name: 'ProductSelectTable',
  data() {
    return {
      loading: false,
      current: null,
      currentId: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        productTypes: [1, 9],
        status: 2
      },
      list: [],
      total: 0
    }
  },
  computed: {
    tagTypes() {
      return this.$route.query.tagModel === '1' ? [1, 2, 3, 4] : [2, 3, 4]
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentRowChange(row) {
      this.current = row
      this.currentId = row.productId
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          vendorId: this.$route.query.vendorId,
          codingTypes: [this.$route.query.codingType],
          tagTypes: this.tagTypes
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getCurrent() {
      return this.current
    }
  }
}
</script>
